import styled from 'styled-components';

import { PAGE_PADDING } from '../styles';

interface WrapperProps {
	zoom: number;
}

const Wrapper = styled('div')`
	flex: 1 1 auto;
	display: flex;
	padding: ${({ zoom }: WrapperProps) => PAGE_PADDING / zoom}px;
	transform: scale(${({ zoom }: WrapperProps) => zoom});
	transform-origin: ${({ zoom }: WrapperProps) => zoom <= 1 ? 'center center' : '0 0'};
`;

const PreviewPageWrapper = styled('div')`
	position: relative;
	flex: 1 1 auto;

	img {
		box-sizing: border-box;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		margin: auto;
	}

	&:first-child:not(:only-child) img {
		margin-right: 0;
	}

	&:last-child:not(:only-child) img {
		margin-left: 0;
	}
`;

export {
	Wrapper,
	PreviewPageWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PreviewPagesSpread/styles.ts